import InputSwitch from './InputSwitch';
import './InputSwitch.scss';

export default InputSwitch;
